module.exports = __webpack_public_path__ + "static/media/user.d7341a08.svg";